module.exports = __webpack_public_path__ + "img/23.85222e41.png";